import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";

const MenuSkeleton = ({ count = 7 }) => {
  return (
    <>
      {[...Array(count)].map((_, i) => (
        <li key={i} className="nav-item mx-4">
          <Skeleton
            width={60}
            height={29}
            borderRadius={4}
            baseColor="#1d4382"
            // highlightColor="#206993"
            highlightColor="#1d4382"
            duration={1.2}
          />
        </li>
      ))}
    </>
  );
};

export default MenuSkeleton;
